export default __webpack_public_path__ + "static/media/icon_chevron-up.df6f6506.svg";